const galleryCarousel = document.querySelector('.shopify-section--main-product product-gallery scroll-carousel');
const gallery = document.querySelector('.shopify-section--main-product product-gallery');
let lastHeight = null;

const observer = new ResizeObserver((entries) => {
  for (let entry of entries) {
    const height = entry.contentRect.height;
    if (lastHeight === null || Math.abs(height - lastHeight) >= 1) {
      lastHeight = height;
      gallery.style.setProperty('--carousel-height', `${height}px`);
    }
  }
});

if (galleryCarousel) {
  observer.observe(galleryCarousel);
}


document.addEventListener('click', function(event) {
  if (event.target.closest('.rating-badge')) {
    const reviewWidget = document.querySelector('[data-oke-widget]');
    if (reviewWidget) {
      reviewWidget.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'start' 
      });
    }
  }
});


const sizeCareIndex = document.querySelector('.size-care_index');
const backToTop = document.querySelector('.back-to-top');

const sizeCareObserver = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (!entry.isIntersecting) {
      backToTop.classList.remove('opacity-0');
    } else {

      backToTop.classList.add('opacity-0');
    }
  });
});

// Start observing the target element
if (sizeCareIndex) {
  sizeCareObserver.observe(sizeCareIndex);
}